export const LOCALE_EN = {
    INVOICE: "Invoice",
    INVOICES: "Invoices",
    CREDIT_NOTE: "Creditnote",
    CREDIT_NOTES: "Creditnotes",
    CREATION_DATE: "Creation Date",
    DELIVERY_DATE: "Delivery Date",
    DELIVERY_ADDRESS: "Delivery Address",
    DELIVERY_COST: "Delivery Cost",
    VENDOR: "Vendor",
    CUSTOMER: "Customer",
    ORDER_NUMBER: "Order Number",
    PAYMENT_METHOD: "Payment Method",
    NOTE: "Note",
    PRODUCT: "Product",
    PRODUCT_DESCRIPTION: "Description",
    PRODUCT_AMOUNT: "Amount",
    PRODUCT_SINGLE_PRICE: "Price",
    DISCOUNT: "Discount",
    TOTAL_DISCOUNTS: "Total discounts",
    TOTAL_BEFORE_DISCOUNTS: "Total excl. discounts",
    TAX_ABBREVIATED: "VAT",
    TAX_AMOUNT: "Tax Amount",
    SPLIT_AMOUNT: "Split Amount",
    BRUTTO: "Gross",
    TOTAL: "Total",
    TOTAL_INCLUDING_VAT: "Total incl. tax",
    TOTAL_EXCLUDING_VAT: "Total excl. tax",
    VAT_ID: "VAT ID",
    TAX_ID: "TAX ID",
    PAID: "Paid",
    UNPAID_AMOUNT: "Unpaid Amount",
    REASON: "Reason",
    INVOICE_LINE_ITEMS_TITLE: "Products",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Creditnotes on products",
    OTHER_CREDIT_NOTES: "Order Adjustment",
    REFUND_SHIPPING_COST: "Refund Shipping Fees",
    REFUND_HAS_BEEN_PAID: "Payment of $VALUE was refunded.",
    REFUND_HAS_BEEN_PAID_FAILED: "Refunding a payment of $VALUE has been failed.",
    DOCUMENTS_FOR_ORDER: "Documents for order",
    NO_INVOICES: "No invoices yet",
    NO_CREDIT_NOTES: "No creditnotes yet",
    DOCUMENTS_ARE_GENERATING: "Documents are generating. Please try again in some minutes.",
    INVALID_REQUEST_PATHWAY_SUPPORT:
        "We could not found any documents for this order. Please send a mail to support@pathway-solutions.de",
    INVALID_REQUEST_GENERIC: "We could not found any documents for this order. Please send a mail to the merchant",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT:
        "We could not found any documents for this order. Please send a mail to ${MAIL}",
    GIFT_CARD_LINE: "The order used a giftcard ${GIFT_CARD_CODE} for ${GIFT_CARD_AMOUNT}.",
    GIFT_CARD: "Gift Card",
    REVERSAL_INVOICE: "Reversal Invoice",
    REVERSAL_CREDIT_NOTE: "Reversal Creditnote",
    DUTY: "Duty",
    USED_DISCOUNTS: "Applied discounts",
    PAYMENT_AT: "Payment on $DATE",
    REFUNDED_CREDITNOTE_AT: "Refund of credit note $CREDIT_NOTE on $DATE",
    REFUNDED_AT: "Refund on $DATE",
    PROCESSING_DOCUMENT: "Processing document",
    DOWNLOAD_DOCUMENTS_TITLE: "Download your document here!",
    MAIL_INTRODUCTION: "For any questions, please contact ${MAIL}",
    REPAYMENT_DIFFERENCE: "Repayment difference",
    DOCUMENT_PREVIEW_BANNER: "Preview – please download the PDF",
};
